/* eslint-disable require-jsdoc */
import React from 'react';
import hasProp from 'hasprop';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFacebook, faTwitter, faInstagram, faBandcamp,
  faYoutube, faSpotify, faSoundcloud,
  faDeezer} from '@fortawesome/free-brands-svg-icons';
import {isValid} from '../../utils/validate';


const socialMediaArray=['', faFacebook, faTwitter, faInstagram, faBandcamp,
  faYoutube, faSpotify, faSoundcloud,
  faDeezer];

const bandSocial = (props) => {
  return (
    <div>
      {hasProp(props, ['bandSocial']) ?
        <div>

          { isValid(props.bandSocial.bands) ?
              props.bandSocial.bands[props.bandIndex].
                  bandSocialMedia.map((item) =>
                    <span key={item.typeId}>
                      <a href={
                        `${item.address}`}
                      target="_blank" rel='noreferrer'
                      className="hearby-icon hearby-social-icon">
                        <FontAwesomeIcon icon={socialMediaArray[item.typeId]} />
                      </a>
                    </span>,
                  ): null
          }

        </div> : null
      }

      {/* {console.log('BandSocial.js props',
          props.bandSocial.bands[0].bandSocialMedia)}
      {console.log('BandSocial.js bandIndex',
          props.bandIndex)} */}

    </div>
  );
};

export default bandSocial;
